import { Link, useNavigate } from "@tanstack/react-router";
import { Button, buttonVariants } from "../../components/ui/button/button";
import { FaceIdIcon } from "../../components/ui/icons";
import { Progress } from "../../components/ui/progress";
import { ENV } from "@/axios/constants";
import MaintenanceNotice from "./MaintenanceNotice";

const FaceIDPage = () => {
	const navigate = useNavigate();

	return (
		<div className="flex flex-col items-center justify-between w-full max-w-[800px] mx-auto h-[100dvh] p-6 bg-white">
			<div className="flex flex-col items-center w-full">
				<Progress value={100} className="h-1 mb-6 w-88" />

				<MaintenanceNotice />

				{/* Title and subtitle */}
				<div className="flex flex-col items-center justify-center w-full">
					<h1 className="mb-2 text-xl font-semibold text-textDark text-center">
						Log in with Face ID
					</h1>
					<p className="w-[60%] text-sm text-textDark text-center">
						Make payments faster and
					</p>
					<p className="w-[60%] text-sm text-textDark text-center">
						more securely with Face ID
					</p>
				</div>
			</div>

			{/* Face icon */}
			<div className="my-12">
				<div className="flex items-center justify-center w-20 h-20 rounded-full bg-primary-600">
					<FaceIdIcon />
				</div>
			</div>

			{/* Buttons */}
			<div className="flex flex-col items-center w-full">
				<Button
					disabled={ENV.VITE_FACE_AUTH !== "true"}
					className="w-full text-white max-w-[312px]"
					onClick={() =>
						navigate({
							to: "/face-auth",
						})
					}
				>
					Log in with Face ID
				</Button>
				<Link
					to={"/sign-mail"}
					className={buttonVariants({
						variant: "link",
					})}
					data-testid="nav-to-email-login"
				>
					Log in with Email
				</Link>
			</div>
		</div>
	);
};

export default FaceIDPage;
